import React from 'react';
import { CopyDetailsText as StyledCopyDetailsText } from '@dealstack/frontend/app/pages/Project/Cap/CapTablePage/common/CopyDetailsText.tsx';
import { DetailValue } from '@dealstack/frontend/app/pages/Project/Cap/CapEntityManageFlow/tabs/Securities/SecurityDetails/styledComponents';

interface Props {
	text: string;
	displayText?: string;
	shouldCapitalize?: boolean;
}

export const CopyableDetailValue: React.FC<Props> = ({ text, displayText, shouldCapitalize }) => {
	return (
		<DetailValue $shouldCapitalize={shouldCapitalize}>
			<StyledCopyDetailsText text={text}>{displayText || text}</StyledCopyDetailsText>
		</DetailValue>
	);
};
